import templateMiddleware from '../../../decorator/private/templateMiddleware';

// TODO: We should move them to a common directory.
export default templateMiddleware;
